
<template>
	<!-- 入库 -->
	<div class="no-group">
		<!-- 表格 -->
		<div class="group-content">
			<div class="group-title">就诊流程_重传FQ</div>
			<div class="model-type">
				<span>您确认重新上传FQ文件吗？</span>
			</div>
			<div :class="{'has-error':isSubmit&&!cancelReason}">
				<a-textarea placeholder="请输入原因......" v-model="cancelReason" :rows="4" />
			</div>
			<div style="margin-top:10px">
				<a-button type="primary" @click="sure()" style="margin-right:16px;">确定</a-button>
				<a-button @click="cancel()">取消</a-button>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        cancelReason: "",
        isSubmit: false
      };
    },
    methods: {
      cancel() {
        this.$emit("close");
      },
      sure() {
        this.isSubmit = true;
        this.$nextTick(() => {
          let errorList = document.querySelectorAll(".has-error");
          if (errorList.length == 0) {
            this.data.cancelReason = this.cancelReason;
            this.$post(
              "patientitem/patientItem/patientItemFolow?operateType=fq-to-be-uploaded",
              this.data,
              {
                "Content-Type": "application/json"
              }
            ).then(
              res => {
                this.$message.success("操作成功");
                this.$emit("close");
              },
              () => {
                this.$message.error("操作失败");
              }
            );
          }
        });
      }
    }
  };
</script>
<style>
	.no-group .popup-container .header {
		height: 40px;
	}
</style>
<style lang="scss" scoped>
	.model-content {
		width: 240px;
		margin: 82px auto 0;
		text-align: left;
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}

		.btn-group {
			margin-top: 25px;
			button {
				width: 100px;
			}
			button:nth-child(2) {
				margin-left: 20px;
			}
		}
	}
	.group-content {
		height: 500px;
		width: 386px;
		margin: 82px auto 0;
		.group-title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			margin-bottom: 52px;
		}
		.model-type {
			font-size: 18px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			margin-top: 52px;
			margin-bottom: 25px;
			span {
				display: block;
			}
			span:nth-child(2) {
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(164, 164, 164, 1);
			}
		}
		textarea {
			width: 386px;
			height: 202px;
			background: rgba(255, 255, 255, 1);
			padding: 10px;
		}
	}
	.table-th {
		color: #a4a4a4;
	}
	.sure-button {
		width: 680px;
		margin: 50px auto 0;
		padding-bottom: 50px;
		.ant-btn {
			height: 42px;
		}
	}
</style>